module.exports = __webpack_public_path__ + "img/m-service-01.602916e0.webp";